import { formatBinding, isMacPlatform } from "@web/shell/keymap";
import { cn } from "@web/lib/cn";

export function Kbd({ children, className }: { children: string; className?: string }) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded border border-line-strong",
        "bg-sunk px-1 text-[11px] leading-none font-medium text-muted",
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** Keycaps for a tinykeys binding; sequences render as "G then I". */
export function Shortcut({ binding, className }: { binding: string; className?: string }) {
  const presses = formatBinding(binding, isMacPlatform());
  return (
    <span className={cn("mm-keys inline-flex items-center gap-1", className)} aria-label={binding}>
      {presses.map((keys, i) => (
        <span key={i} className="inline-flex items-center gap-0.5">
          {i > 0 ? <span className="px-0.5 text-[11px] text-faint">then</span> : null}
          {keys.map((k) => (
            <Kbd key={k}>{k}</Kbd>
          ))}
        </span>
      ))}
    </span>
  );
}
